<template>
  <div>
    <h1 class="page-header">{{ $t('purchaseorder.purchaseorder') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-9">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'purchase-order-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-3 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'supplier_name'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.branch_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.po_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.po_number }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="'PDF'" class="mr-3 text-danger" @click.prevent="printPdf(record)">
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                href="#"
                v-tooltip="'Edit'"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="'Delete'"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <ts-branch-filter @filter="value => (branch_id = value)" />
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'purchase-order',
  data() {
    return {
      loading: false,
      visible: false,
      waiting: false,
      show_pdf: false,
      src: '',
      branch_id: []
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('purchaseOrder', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.purchaseOrder.search
      },
      set(newValue) {
        this.$store.commit('purchaseOrder/SET_SEARCH', newValue)
        this.$store.commit('purchaseOrder/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('purchaseorder.branch') },
        { name: this.$t('purchaseorder.date') },
        { name: this.$t('purchaseorder.ponumber') },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'purchaseOrder/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('purchaseOrder/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'purchase-order-edit',
        params: { id: record.po_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('purchaseOrder/destroy', record.po_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    printPdf (record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('purchaseOrder/printPdf', record.po_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'purchase-order-create') {
      this.$store.commit('purchaseOrder/RESET_STATE')
    }
    next()
  }
}
</script>
